import React from "react";
import {
  useEntityUnreadCount,
  useScopeUnreadCount,
  useScopesUnreadCount,
} from "../../context/NotificationsContext/NotificationsProvider";

const BadgePill = ({ count, max = 99, className = "", dotOnly = false }) => {
  if (!count) return null;
  if (dotOnly) {
    return (
      <span
        className={`inline-block h-[0.65rem] w-[0.65rem] rounded-kit-full bg-badge ${className}`}
      />
    );
  }

  return (
    <span
      className={`inline-flex min-w-[1.15rem] h-[1.15rem] items-center justify-center rounded-kit-full bg-badge px-kit-4 text-kit-2xs font-['Primary-Bold'] leading-none text-on-fill ${className}`}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
};

/**
 * Reusable unread-count badge for a notification scope or entity.
 * Renders nothing when there are no unread notifications.
 *
 * Usage: <NotificationBadge scope="dashboard:bookings" />
 *        <NotificationBadge entityId={roster._id} dotOnly />
 */
const NotificationBadge = ({
  scope,
  entityId,
  className = "",
  max = 99,
  dotOnly = false,
}) => {
  const scopeCount = useScopeUnreadCount(scope);
  const entityCount = useEntityUnreadCount(entityId);
  const count = entityId ? entityCount : scopeCount;
  return <BadgePill count={count} max={max} className={className} dotOnly={dotOnly} />;
};

/** badge summing unread counts across several scopes (e.g. a menu group) */
export const ScopesNotificationBadge = ({ scopes, className = "", max = 99, dotOnly = false }) => {
  const count = useScopesUnreadCount(scopes);
  return <BadgePill count={count} max={max} className={className} dotOnly={dotOnly} />;
};

export default NotificationBadge;
